import React from "react";
import { CardHeader } from "@/components/ui/card";
import { X } from "lucide-react";

/**
 * ContestField - Contest dropdown/switcher UI
 * Shows contest name with navigation arrows and close button
 */
const ContestField = ({ contests, contestIndex, onContestChange, onClose }) => {
	if (!contests || contests.length === 0) {
		return null;
	}

	return (
		<CardHeader className="relative rounded-t-2xl border-b border-gray-200 bg-gradient-to-r from-purple-50 to-pink-50 px-2 py-2 dark:border-gray-700 dark:from-purple-900/20 dark:to-pink-900/20 sm:px-3 sm:py-3">
			{/* Close button - Top right corner */}
			{onClose ? (
				<button
					onClick={onClose}
					className="absolute right-2 top-2 z-50 flex h-6 w-6 items-center justify-center rounded-full border border-red-600 bg-red-500 font-bold text-white shadow-lg transition-colors hover:border-red-700 hover:bg-red-600"
					aria-label="Close"
				>
					<X size={14} className="text-white" />
				</button>
			) : null}
			<div className="flex w-full min-w-0 items-center justify-between gap-2 sm:gap-4">
				{contests.length > 1 && (
					<button
						onClick={() => onContestChange(contestIndex - 1)}
						className="mt-5 flex h-8 w-8 items-center justify-center rounded-full border-2 border-purple-300 bg-white font-bold text-purple-600 shadow-sm transition-colors hover:bg-purple-100 dark:border-purple-600 dark:bg-gray-700 dark:text-purple-400 dark:hover:bg-purple-800"
					>
						‹
					</button>
				)}
				<div className="min-w-0 flex-1 text-center">
					<div className="mb-1 text-xs font-semibold uppercase tracking-wider text-gray-600 dark:text-gray-300 sm:mb-2 sm:text-sm">
						Posting to
					</div>
					<div
						className={`truncate text-xl font-black tracking-tight sm:text-3xl ${
							contests[contestIndex].toLowerCase() === "glow game"
								? "text-orange-600 drop-shadow-[0_2px_8px_rgba(251,146,60,0.6)] dark:text-orange-300"
								: "bg-gradient-to-r from-purple-600 via-pink-600 to-purple-600 bg-clip-text text-transparent drop-shadow-[0_2px_8px_rgba(168,85,247,0.4)]"
						}`}
					>
						{contests[contestIndex]}
					</div>
				</div>
				{contests.length > 1 && (
					<button
						onClick={() => onContestChange(contestIndex + 1)}
						className="mt-5 flex h-8 w-8 items-center justify-center rounded-full border-2 border-purple-300 bg-white font-bold text-purple-600 shadow-sm transition-colors hover:bg-purple-100 dark:border-purple-600 dark:bg-gray-700 dark:text-purple-400 dark:hover:bg-purple-800"
					>
						›
					</button>
				)}
			</div>
		</CardHeader>
	);
};

export default ContestField;
